angular.module('impactx.smartform').controller('SmartFormComponentCtrl', [
    '$scope',
    'TranslationService',
    '$mdPanel',
    '$element',
    'SmartFormTemplateCache',
    'SmartFormService',
    'ToastService',
    SmartFormComponentController]);

function SmartFormComponentController($scope, TranslationService, $mdPanel, $element, SmartFormTemplateCache, SmartFormService, ToastService) {
    var self = this;

    self.errors = {
        countryCode: TranslationService.get('countryCode'),
        areaCode: TranslationService.get('areaCode'),
        networkCode: TranslationService.get('networkCode'),
        numberCode: TranslationService.get('numberCode'),
        required: TranslationService.get('required'),
        email: TranslationService.get('invalidEmailField'),
        invalidUrl: TranslationService.get('invalidUrlField'),
        invalidNumber: TranslationService.get('invalidNumberFields'),
        zeroNotAllowed: TranslationService.get('zeroNotAllowed'),
        invalidCountryCode: TranslationService.get('invalidCountryCode'),
        invalidAreaCode: TranslationService.get('invalidAreaCode'),
        invalidNetworkCode: TranslationService.get('invalidNetworkCode'),
        invalidNumberCode: TranslationService.get('invalidNumberCode'),
        errorMinlength: TranslationService.get('error_minlength'),
        errorMaxlength: TranslationService.get('error_maxlength'),
        errorMin: TranslationService.get('error_min'),
        errorMax: TranslationService.get('error_max'),
        errorCheckboxGroupMin: TranslationService.get('errorCheckboxGroupMin'),
        errorCheckboxGroupMax: TranslationService.get('errorCheckboxGroupMax'),
        errorCheckboxGroupFreetextLabel: TranslationService.get('errorCheckboxGroupFreetextLabel'),
        errorDateFormat: TranslationService.get('error_date'),
        onlyWeekdays: TranslationService.get('onlyWeekdays'),
        onlyWeekends: TranslationService.get('onlyWeekends'),
        provideDateAfter: TranslationService.get('provideDateAfter'),
        provideDateBefore: TranslationService.get('provideDateBefore')
    };

    SmartFormService.getTranslations().then(function (translations) {
        self.trns = translations;
    });

    // calculates the actual height of the text and adjusts the gridster item.
    // only needed for the plain text component
    if ($scope.component.component == 'text') {
        $scope.$watch(function () {
            return $element.find('p').height();
        }, function (newValue) {
            if (newValue) {
                var minSizeY = Math.ceil($element.find('p').height() / 48);
                $scope.component.layout.minSizeY = minSizeY;
                $scope.component.layout.sizeY = minSizeY;
            }
        });
    }

    if ($scope.component.component === "date") {
        $scope.$watch("isCalendarOpen", function(newValue) {
            if (newValue === true) {
                if (!$scope.component.value) {
                    var date = new Date();
                    date.setDate(1);
                    $scope.component.value = date;
                }
            }
        });
    }

    self.openConfigurationPanel = function (event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        $scope.component.layout.isSelected = true;

        var configurationPanelSettings = {
            attachTo: angular.element('#ix-main-view'),
            controller: 'SmartFormComponentConfigurationPanelCtrl',
            controllerAs: 'ctrl',
            locals: {
                smartFormIdentifier: $scope.smartFormIdentifier,
                component: $scope.component
            },
            position: $mdPanel.newPanelPosition()
                .relativeTo($element)
                .left()
                .addPanelPosition(
                    $mdPanel.xPosition.OFFSET_END,
                    $mdPanel.yPosition.CENTER
                ),
            event: event,
            templateUrl: $scope.component.configurationPanelTemplateUrl,
            clickOutsideToClose: true,
            onRemoving: function () {
                $scope.component.layout.isSelected = false;
            }
        };

        $mdPanel.open(configurationPanelSettings);
    };

    self.deleteComponent = function () {
        SmartFormTemplateCache.removeComponent($scope.smartFormIdentifier, $scope.component.identifier);
        ToastService.openActionToast(SmartFormService.getTranslation('removedComponentSuccess'), SmartFormService.getTranslation('revert'), function () {
            SmartFormTemplateCache.reviveComponent();
        });
    };

    self.adjustDateValue = function () {
        if ($scope.component.value) {
            $scope.component.value = new Date($scope.component.value);
        }
        if($scope.component.minDate) {
            $scope.component.minDate = new Date($scope.component.minDate);
        }
        if($scope.component.maxDate) {
            $scope.component.maxDate = new Date($scope.component.maxDate);
        }
    };

    self.dayFilter = function (date) {
        var day = date.getDay();
        if ($scope.component.onlyWeekdays) {
            return day > 0 && day < 6;
        }
        else if ($scope.component.onlyWeekends) {
            return day == 0 || day == 6;
        }
        else {
            return true;
        }
    }

    self.timeChange = function (event) {
        $scope.component.value = event;
    }
}